import { gql } from "@apollo/client";

export const GET_USER_SCRIPTS = gql`
  query GetUserScripts($userID: ID!) {
    getUserScripts(userID: $userID) {
      script_id
      script_name
      script_content
      created_at
      updated_at
    }
  }
`;

export const SAVE_USER_SCRIPT = gql`
  mutation SaveUserScript($userID: ID!, $script_name: String!, $script_content: String!) {
    saveUserScript(userID: $userID, script_name: $script_name, script_content: $script_content) {
      script_id
      script_name
      script_content
      created_at
      updated_at
    }
  }
`;

export const DELETE_USER_SCRIPT = gql`
  mutation deleteUserScript($script_id: Int!, $script_name: String!) {
    deleteUserScript(script_id: $script_id, script_name: $script_name) {
      script_id
      script_name
      script_content
      created_at
      updated_at
    }
  }
`;